<template>
  <v-card outlined class="mt-4">
    <v-btn text block class="justify-start" @click="expanded = !expanded">
      {{ title }}{{ expanded ? '（點此收合）' : '（點此查看）' }}
    </v-btn>
    <v-card-text v-if="expanded">
      <div v-for="(item, index) in items" :key="`${item.value}-${index}`" class="py-1">
        {{ item.value }}：{{ itemText(item) }}
      </div>
      <div v-if="!items.length" class="text-center">{{ emptyText }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
import { excludedReasonText } from '@/utils/customListPhones'

export default {
  name: 'ExcludedList',
  props: {
    items: { type: Array, required: true },
    title: { type: String, required: true },
    emptyText: { type: String, default: '尚無排除' }
  },
  data() {
    return { expanded: false }
  },
  methods: {
    itemText(item) {
      return item.merged_into ? `併入 ${item.merged_into}` : excludedReasonText(item.reason)
    }
  }
}
</script>
